module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check"
  }, [_c('Checkbox', {
    model: {
      value: (_vm.check),
      callback: function($$v) {
        _vm.check = $$v
      },
      expression: "check"
    }
  }), _c('p', {
    staticClass: "check_text"
  }, [_vm._v("Я соглашаюсь с "), _c('ExtLink', _vm._b({}, 'ExtLink', _vm.policyURL, false))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fbdb522","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/form/components/check/Check.vue
// module id = d30d312bbc1564650150
// module chunks = 89